/**
 * 购物车上下文 - 管理全局购物车状态
 */
import React, { createContext, useContext, useState, useCallback } from 'react';
import { cartApi } from '../api';
import { message } from 'antd';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState({ items: [], subtotal: 0, itemCount: 0 });
  const [cartLoading, setCartLoading] = useState(false);

  /** 刷新购物车 */
  const refreshCart = useCallback(async () => {
    try {
      setCartLoading(true);
      const data = await cartApi.getCart();
      setCart(data);
    } catch {}
    finally { setCartLoading(false); }
  }, []);

  /** 添加到购物车 */
  const addToCart = useCallback(async (variantId, quantity = 1) => {
    const data = await cartApi.addItem({ variantId, quantity });
    setCart(data);
    message.success('已加入购物车');
    return data;
  }, []);

  /** 更新数量 */
  const updateQuantity = useCallback(async (itemId, quantity) => {
    const data = await cartApi.updateItem(itemId, quantity);
    setCart(data);
    return data;
  }, []);

  /** 删除商品 */
  const removeItem = useCallback(async (itemId) => {
    const data = await cartApi.removeItem(itemId);
    setCart(data);
    return data;
  }, []);

  /** 清空购物车 */
  const clearCart = useCallback(async () => {
    const data = await cartApi.clearCart();
    setCart(data);
    message.success('购物车已清空');
    return data;
  }, []);

  return (
    <CartContext.Provider value={{ cart, cartLoading, refreshCart, addToCart, updateQuantity, removeItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
